// extracted by mini-css-extract-plugin
export default {"bluebook-player":"bluebook-player-f36mK"};